__turbopack_context__.v({
  "ctaSection": "hero-banner-module-scss-module__nO5veW__ctaSection",
  "heroBanner": "hero-banner-module-scss-module__nO5veW__heroBanner",
  "heroBanner--DeepBlue": "hero-banner-module-scss-module__nO5veW__heroBanner--DeepBlue",
  "heroBanner--PeriwinkleGrey": "hero-banner-module-scss-module__nO5veW__heroBanner--PeriwinkleGrey",
  "heroBanner--equalWidth": "hero-banner-module-scss-module__nO5veW__heroBanner--equalWidth",
  "heroBanner--firstComponent": "hero-banner-module-scss-module__nO5veW__heroBanner--firstComponent",
  "heroBanner--imageBelowText": "hero-banner-module-scss-module__nO5veW__heroBanner--imageBelowText",
  "heroBanner--imagePosition": "hero-banner-module-scss-module__nO5veW__heroBanner--imagePosition",
  "imageContent": "hero-banner-module-scss-module__nO5veW__imageContent",
  "textContent": "hero-banner-module-scss-module__nO5veW__textContent",
  "textContent--design-2": "hero-banner-module-scss-module__nO5veW__textContent--design-2",
  "videoContent": "hero-banner-module-scss-module__nO5veW__videoContent",
  "videoContent--Left": "hero-banner-module-scss-module__nO5veW__videoContent--Left",
  "videoContent--Right": "hero-banner-module-scss-module__nO5veW__videoContent--Right",
});
